import React, { useState } from "react";
import useRandomColor from "../hooks/useRandomColor";
import { theme } from "./theme";

const YMLogo = ({ fill, className, style, size, onClick }) => {
  const { generateRandomHexColor } = useRandomColor();
  const [bgColor, setBgColor] = useState(theme.main);

  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "100px"}
      height={size ? size : "100px"}
      viewBox="0 0 1550.000000 908.000000"
      preserveAspectRatio="xMidYMid meet"
      onClick={() => {
        !fill && setBgColor(generateRandomHexColor());
      }}
      className={className + `flex max-h-[${size}px] max-w-[${size}px]`}
      fill={fill ? fill : bgColor}
      style={style && { ...style, zIndex: 999 }}
    >
      <g
        transform="translate(0.000000,908.000000) scale(0.100000,-0.100000)"
        stroke="none"
      >
        <path
          d="M570 9071 c-155 -22 -264 -75 -376 -186 -61 -60 -90 -98 -118 -155
-78 -159 -70 104 -74 -2660 -2 -1846 0 -2494 9 -2550 37 -244 200 -439 433
-518 l81 -27 1552 -3 1553 -2 2 -1228 3 -1227 28 -82 c52 -155 161 -286 297
-357 134 -70 139 -71 680 -71 432 0 492 2 550 18 243 65 430 262 475 500 23
119 22 1822 0 1935 -48 239 -234 435 -475 498 -58 15 -148 18 -812 21 l-748 4
0 1005 0 1004 724 0 c770 0 804 2 924 49 169 67 305 212 368 392 l29 84 3
1480 c3 1660 6 1571 -69 1725 -57 115 -170 231 -279 283 -150 73 -136 72 -800
72 -592 0 -595 0 -675 -23 -119 -35 -190 -77 -281 -167 -60 -60 -90 -99 -117
-155 -75 -153 -71 -101 -74 -1020 l-3 -825 72 -45 c94 -58 270 -232 338 -334
73 -109 136 -247 167 -363 23 -87 26 -118 27 -273 1 -111 -4 -197 -12 -235
-58 -267 -195 -485 -410 -656 -186 -149 -381 -226 -630 -249 -367 -34 -694 82
-947 335 -192 191 -298 399 -336 655 -16 113 -7 322 20 422 71 271 257 521
514 691 l77 52 0 796 c0 896 0 891 -70 1038 -55 114 -170 231 -280 284 -147
72 -134 71 -740 73 -300 1 -570 -1 -600 -5z"
        />
        <path
          d="M8657 9074 c-4 -4 -7 -484 -7 -1067 0 -1005 1 -1059 18 -1052 125 48
409 69 567 42 238 -42 441 -150 628 -334 229 -224 342 -472 354 -774 6 -153
-5 -256 -43 -387 -72 -246 -251 -492 -461 -632 l-82 -55 -1 -636 c0 -601 1
-640 20 -713 66 -259 273 -440 547 -477 50 -6 287 -9 658 -6 517 3 586 5 640
21 233 68 401 239 461 467 15 56 18 142 21 700 l4 636 -85 57 c-229 153 -422
423 -492 691 -32 122 -44 345 -24 477 22 154 90 325 181 460 126 185 331 354
526 434 l58 23 -620 3 c-610 3 -621 3 -678 25 -85 32 -145 79 -181 143 l-31
55 -5 685 c-6 682 -6 685 -29 755 -38 117 -80 184 -166 270 -88 89 -158 131
-275 166 -74 23 -80 23 -785 27 -391 2 -714 0 -718 -4z"
        />
        <path
          d="M12157 9074 c-4 -4 -7 -483 -7 -1065 l0 -1058 48 14 c143 43 365 57
528 34 505 -70 913 -486 983 -1002 60 -439 -142 -891 -506 -1133 l-84 -57 3
-641 c4 -632 4 -642 27 -716 32 -108 84 -195 165 -276 83 -83 169 -134 281
-166 80 -23 81 -23 715 -23 575 0 641 2 700 18 226 61 404 235 467 457 17 62
18 142 18 1620 0 1515 0 1556 -19 1607 -42 111 -143 208 -255 243 -58 18 -92
20 -400 20 -244 0 -351 4 -392 14 -112 26 -214 108 -266 214 l-28 57 -6 645
c-5 561 -8 653 -23 709 -60 231 -235 406 -467 468 -57 15 -142 17 -769 20
-388 2 -709 1 -713 -3z"
        />
        <path
          d="M6683 6931 c-190 -47 -341 -170 -424 -347 -72 -153 -70 -91 -67
-1660 4 -1562 -2 -1436 75 -1594 51 -104 169 -222 273 -273 150 -73 136 -72
795 -72 659 0 645 -1 795 72 104 51 222 169 273 273 73 150 71 123 75 836 l3
642 -68 45 c-195 130 -367 336 -453 544 -108 258 -119 568 -30 830 98 289 355
566 639 690 l76 33 -945 -1 c-870 0 -951 -2 -1017 -18z"
        />
      </g>
    </svg>
  );
};

export default YMLogo;
